module.exports = __webpack_public_path__ + "static/media/folder-plus.83563d78.svg";